import api from "./api";

const API_URL = "/deliveryroute";

/* ==========================
   SAFE REQUEST
========================== */
const safe = async (fn, fallback = null) => {
    try {
        const res = await fn();
        return res?.data ?? fallback;
    } catch (err) {
        console.warn("API warning:", err?.response?.data ?? err?.message);
        return fallback;
    }
};

export default {
    getAll: async () => {
        return safe(() => api.get(API_URL), []);
    },

    getById: async (id) => {
        return safe(() => api.get(`${API_URL}/${id}`));
    },

    create: async (data) => {
        return safe(() => api.post(API_URL, data));
    },

    update: async (id, data) => {
        return safe(() => api.put(`${API_URL}/${id}`, data));
    },

    delete: async (id) => {
        return safe(() => api.delete(`${API_URL}/${id}`));
    },
};